export let life = {
  created () {
    this.methods('fetchListStation')
  }
}
export let event = {}
export let watch = {
  '$store.state.app.nodes': function () {
    this.methods('fetchListStation')
  }
}
